// todo: i18n
export function time_ago_human(time_ago) { // todo: remove export, won't be needed when using time_ago_txt() everywhere
  var time_ago_txt = "";
  if((time_ago/60) > 24) {
    time_ago_txt += "meer dan "; // "over "
    time_ago = Math.floor(time_ago / 60 / 24); // days
    time_ago_txt += time_ago;
    if(time_ago > 1) {
      time_ago_txt += " dagen geleden"; // " days ago"
    } else {
      time_ago_txt += " dag geleden"; // " day ago"
    }
  } else if(time_ago > 60) {
    time_ago_txt += "meer dan ";
    time_ago = Math.floor(time_ago / 60); // hours
    time_ago_txt += time_ago;
    time_ago_txt += " uur geleden";
    // if(time_ago > 1) {
    //   time_ago_txt += " hours ago";
    // } else {
    //   time_ago_txt += " hour ago";
    // }
  } else {
    time_ago_txt += Math.floor(time_ago);
    time_ago_txt += " minuten geleden"; // " minutes ago"
  }
  return time_ago_txt;
}

export function time_ago_txt(created_on) {
  created_on = new Date(created_on);
  var now = new Date();
  var time_ago = (now.getTime() - created_on.getTime()) / 1000 / 60; // minutes
  return time_ago_human(time_ago);
}

export function days_to_go(date_to, date_from) {
  date_from = (typeof date_from !== 'undefined') ? date_from : null;
  date_to = new Date(date_to);
  var date_start = new Date(); // now
  if(date_from) {
    date_start = new Date(date_from);
  }
  var minutes_to_go = (date_to.getTime() - date_start.getTime()) / 1000 / 60;
  return Math.ceil(minutes_to_go / 60 / 24);
}

export function time_togo(date_to, date_from) {
  date_from = (typeof date_from !== 'undefined') ? date_from : null;
  date_to = new Date(date_to);
  var date_start = new Date(); // now
  if(date_from) {
    date_start = new Date(date_from);
  }
  var minutes_to_go = (date_to.getTime() - date_start.getTime()) / 1000 / 60;
  if((minutes_to_go/60) > 24) {
    var days_togo = Math.ceil(minutes_to_go / 60 / 24);
    if(days_togo > 1) {
      return days_togo+" dagen"; // " days"
    } else {
      return days_togo+" dag"; // " day"
    }
  } else if(minutes_to_go > 60) {
    var hours_togo = Math.ceil(minutes_to_go / 60);
    return hours_togo+" uur"; // " hour"
  } else {
    var mins_togo = Math.ceil(minutes_to_go);
    if(mins_togo > 1) {
      return mins_togo+" minuten"; // " minutes"
    } else {
      return mins_togo+" minuut"; // " minute"
    }
  }
}

export function calc_age(birthdate) {
  var bd = new Date(birthdate);
  var now = new Date();
  var age_now = now.getFullYear() - bd.getFullYear(); // age this year
  if(now.getMonth() < bd.getMonth()) {
    age_now = age_now - 1;
  } else if(now.getMonth() === bd.getMonth()) {
    if(now.getDate() < bd.getDate()) {
      age_now = age_now - 1;
    }
  }
  return age_now;
}



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/modules/time_ago.js
// module id = 194
// module chunks = 0